import request from '../utils/request';

export function postArticleId (data){
    return request({
        url: "/wxmanager/article/articleView",
        method:'post',
        data,
    });
}

export function postArticleAns (data){
    return request({
        url: "/wxmanager/article/articleAns",
        method:'post',
        data,
    });
}

export function postArticleList (){
    return request({
        url: "/wxmanager/article/articleList",
        method:'post'
    });
} 